import React from "react";
import Radio from "components/shared/Radio";

export default function SubscriptionRadio(props) {
  return (
    <Radio {...props} inputData={{ name: props.subscriptionType }}>
      <strong>{props.subscriptionType} subscription</strong>
      <span className="price">
        <span className="tw-hidden sm:tw-inline"> ⋅ </span>
        <div className="sm:tw-hidden" />
        {props.cost} {props.currency || "USD"} per {props.period}. Cancel
        anytime.
      </span>
      <span className="discounted-price text-success">
        {props.discountedCost} for the first {props.period}
      </span>
    </Radio>
  );
}
